export default {
  dbl_home_header_title: 'Home',
  dbl_home_quick_analysis: 'Quick Analysis',
  dbl_home_dashboard: 'Dashboard',
  dbl_home_dashboard_desc: 'Create Dashboard',
  dbl_home_chart: 'Chart',
  dbl_home_chart_desc: 'Design Chart',
  dbl_home_tables: 'Table',
  dbl_home_tables_desc: 'Manage Data Source',
  dbl_home_user_group: 'User Group Analysis',
  dbl_home_user_group_desc: 'Manage User Groups',

  dbl_home_getting_start_title: 'Getting Start',
  dbl_home_getting_start_info: 'Below are common tasks that new users do that will help kick start your project.',
  dbl_home_getting_start_learn: 'Learn More',
  dbl_home_getting_start_know: 'Got it',
  dbl_home_getting_start_not_show: `Skip`,

  dbl_home_recently_view: 'Recently Viewed',
  dbl_home_table_name: 'Name',
  dbl_home_table_category: 'Category',
  dbl_home_table_recently_view_time: 'Recently View Time',
  dbl_home_table_owner: 'Owner',
  dbl_home_share_with_me: 'Shared with Me({count})',
  dbl_home_search_name: 'Search Name',
  dbl_home_search_dashboard_name: 'Search Dashboard Name',
  dbl_home_table_share_time: 'Share Time',
  dbl_home_search_template_placeholder: 'Search by template name',
  dbl_home_search_dashboard_placeholder: 'Search by dashboard or chart name',


  dbl_home_template_center: 'Template Center({count})',
  dbl_home_sub_all: 'All({count})',
  dbl_home_sub_game: 'Game Template({count})',
  dbl_home_sub_public: 'Public Template({count})',
  dbl_home_sub_card: 'Card',
  dbl_home_sub_table: 'Table',
  dbl_home_table_total: "{total} total items",
  dbl_home_created_by: "Created by",
  dbl_home_dashboard_name: "Dashboard Name",
  dbl_home_template_name: "Template Name",
  dbl_home_dashboard_creator: "Creator",
  dbl_home_dashboard_visits: "Visits",
  dbl_home_dashboard_create_time: "Create Time",
	
};
